import { render, staticRenderFns } from "./HmStatus.vue?vue&type=template&id=2bc720b7&scoped=true&"
var script = {}
import style0 from "./HmStatus.vue?vue&type=style&index=0&id=2bc720b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc720b7",
  null
  
)

component.options.__file = "HmStatus.vue"
export default component.exports